/**
 * How often a live room should ask the server for news.
 *
 * A lesson is bursty: a flurry of questions, then quiet while the teacher
 * talks. Polling at one fixed rate is wrong in both halves — too slow during
 * the flurry, and wasteful for the twenty minutes nobody types. The cadence
 * steps down a ladder while nothing arrives and drops back to the top the
 * moment something does.
 *
 * Pure so the ladder can be reasoned about and tested without a browser.
 */

/** Chosen so a busy room feels live, and a quiet one costs almost nothing. */
export const CADENCE_MS = [2500, 5000, 12000, 30000];

export const FASTEST = 0;
export const SLOWEST = CADENCE_MS.length - 1;

/**
 * The next rung.
 * @param {number} step   the rung currently on
 * @param {boolean} hadNews whether the last poll brought anything
 */
export const nextStep = (step, hadNews) => {
  if (hadNews) return FASTEST;
  return Math.min(step + 1, SLOWEST);
};

export const intervalFor = (step) => CADENCE_MS[Math.min(Math.max(step, 0), SLOWEST)];

/**
 * Requests per minute at a given rung — used in comments and reasoning about
 * load, and worth having as code so the numbers cannot drift from the ladder.
 */
export const requestsPerMinute = (step) => 60000 / intervalFor(step);
